import { SvgIconProps } from "@material-ui/core";
import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

const CheckboxIndeterminate = createSvgIcon(
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="4" fill="#009FB8" />
    <rect x="3" y="7" width="10" height="2" rx="1" fill="white" />
  </svg>,
  "CheckboxIndeterminate"
);

export default (props: SvgIconProps) => (
  <CheckboxIndeterminate {...props} viewBox="0 0 16 16" />
);
